import { render, staticRenderFns } from "./NewBookList.vue?vue&type=template&id=24e2bada&scoped=true&"
import script from "./NewBookList.vue?vue&type=script&lang=js&"
export * from "./NewBookList.vue?vue&type=script&lang=js&"
import style0 from "./NewBookList.vue?vue&type=style&index=0&id=24e2bada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2bada",
  null
  
)

export default component.exports